var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryScheduled = function SvgDeliveryScheduled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "inherit",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.777 10.146h-5.33a.876.876 0 0 1-.876-.876V4.494l.005.016h2.094c.844 0 1.613.48 1.983 1.238l2.049 3.194c.049.1.074.211.074.323zM5.566 12.187a2.79 2.79 0 1 0 0 5.578 2.79 2.79 0 0 0 0-5.578M15.537 12.187a2.79 2.79 0 1 0 0 5.578 2.79 2.79 0 0 0 0-5.578",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.776 4.207C.776 2.988 1.764 2 2.983 2h10.499c.975 0 1.803.633 2.094 1.51l.7 4.873q.108 0 .175-.004c-.151.046-.359.186-.175.563h4.426c.049.1.074.211.074.323v3.69a2.207 2.207 0 0 1-2.206 2.206H2.983a2.207 2.207 0 0 1-2.207-2.206zM16.58 8.36c.011.003-.02.013-.128.018a.3.3 0 0 1 .128-.018m-3.93-2.9a.896.896 0 0 0-.911-.451.9.9 0 0 0-.598.367L7.976 9.745 6.231 8.39a.887.887 0 0 0-1.273.188.965.965 0 0 0 .182 1.316l2.476 1.918a.887.887 0 0 0 1.27-.19l3.709-5.12a.95.95 0 0 0 .172-.696 1 1 0 0 0-.117-.346",
    clipRule: "evenodd"
  })));
};
export default SvgDeliveryScheduled;